/**
 * @class RegistrationForm
 */
export default class RegistrationForm {
    /**
     * @param {Object} contactPerson
     * @param {Object} pointOfSale
     * @param {Object} machineInformation
     */
    constructor(contactPerson, pointOfSale, machineInformation) {
        this._contactPerson = contactPerson;
        this._pointOfSale = pointOfSale;
        this._machineInformation = machineInformation;
    }

    /**
     * @return {Object}
     */
    get contactPerson() {
        return this._contactPerson;
    }

    /**
     * @return {String}
     */
    get contactName() {
        return this._contactPerson.name;
    }

    /**
     * @return {String}
     */
    get contactPhone() {
        return this._contactPerson.phone;
    }

    /**
     * @return {String}
     */
    get contactEmail() {
        return this._contactPerson.email;
    }

    /**
     * @param {Object} contactPerson
     */
    set contactPerson(contactPerson) {
        this._contactPerson = contactPerson;
    }

    /**
     * @return {Object}
     */
    get pointOfSale() {
        return this._pointOfSale;
    }

    /**
     * @return {String}
     */
    get posName() {
        return this._pointOfSale.name;
    }

    /**
     * @return {String}
     */
    get posStreet() {
        return this._pointOfSale.street;
    }

    /**
     * @return {String}
     */
    get posCountry() {
        return this._pointOfSale.country;
    }

    /**
     * @return {String}
     */
    get posRegion() {
        return this._pointOfSale.region;
    }

    /**
     * @return {String}
     */
    get posCity() {
        return this._pointOfSale.city;
    }

    /**
     * @return {String}
     */
    get posZip() {
        return this._pointOfSale.zip;
    }

    /**
     * @param {Object} pointOfSale
     */
    set pointOfSale(pointOfSale) {
        this._pointOfSale = pointOfSale;
    }

    /**
     * @return {Object}
     */
    get machineInformation() {
        return this._machineInformation;
    }

    /**
     * @return {String}
     */
    get machineSerialNumber() {
        return this._machineInformation.serialNumber;
    }

    /**
     * @return {String}
     */
    get machineProducer() {
        return this._machineInformation.producer;
    }

    /**
     * @return {String}
     */
    get machineType() {
        return this._machineInformation.type;
    }

    /**
     * @return {String}
     */
    get machineNumberOfCanisters() {
        return this._machineInformation.numberOfCanisters;
    }

    /**
     * @param {Object} machineInformation
     */
    set machineInformation(machineInformation) {
        this._machineInformation = machineInformation;
    }

    /**
     * @return {Array}
     */
    get props() {
        return [
            "contactName",
            "contactPhone",
            "contactEmail",
            "posName",
            "posStreet",
            "posCountry",
            "posRegion",
            "posCity",
            "posZip",
            "machineSerialNumber",
            "machineProducer",
            "machineType",
            "machineNumberOfCanisters"
        ];
    }
}
